module.exports = __webpack_public_path__ + "static/coffee-66850_1280@2x-8d9853df10719125809067a35f699711.png";